@defer (when value()) {
  <app-role-form
    [delete]="true"
    [profile]="profile()"
    [access]="access()"
    [(value)]="value"
    [id]="id">
  </app-role-form>
}
